export default __webpack_public_path__ + "media/zurb/img/icons/favicon/mstile-310x150-fc9cc0a4e31ae4260cfa1517e04c2f76.png";